import { ReactComponent as WagonIconSvg } from "../../wagon_icon.svg"

const WagonIcon = ({ width = 24, height = 24, ...props }) => (
  <WagonIconSvg width={width} height={height} {...props} />
)

export default WagonIcon
